import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { mediumScreens, lowHeightScreens, smallScreens } from 'components/common/fontElements';
import { DecisionTreeButton } from 'components/common/buttonsComponents';

export const TopContainer = styled.div`
  height: 100%;
  overflow-y: scroll;
  position: relative;
`;

export const Container = styled.div`
  display: flex;
  padding: 100px 30px 200px 30px;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: ${(props) => (props.fullWidth ? '100%' : '70%')};
  margin: 0px auto;
  @media (max-height: ${lowHeightScreens}) {
    padding: 70px 20px 25px 20px;
  }
  @media (max-width: ${mediumScreens}) {
    width: 100%;
  }
  @media (max-height: ${smallScreens}) {
    padding: ${(props) => props.reduceTopPadding && '30px 20px 200px 20px'};
  }
`;

export const ActionsButtonsWrapper = styled.div`
  text-align: center;
  margin-bottom: 100px;
`;

export const BackButtonWrapper = styled.div`
  padding: 18px 30px;
  z-index: 50;
  bottom: 0;
  position: fixed;
  width: 100%;
  min-height: 65px;
  background-color: ${colors.baseBackground};
  box-shadow: 0px -4px 15px rgba(23, 45, 70, 0.08);
`;

export const Title = styled.p`
  padding: 0px 30px;
  padding-bottom: 30px;
  font-family: 'Lato-Bold';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 12px;
  }
`;

export const SubText = styled.p`
  padding: 14px 16px;
  font-family: 'Lato';
  margin-bottom: 0px !important;
  text-align: center;
  font-size: 11px;
  color: ${colors.black1};
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 11px;
  }
`;

export const SubTextLink = styled(SubText)`
  text-decoration: underline;
  cursor: pointer;
`;

export const ExpertQuestionSection = styled.div`
  padding-bottom: 30px;
`;

export const InfoWrapper = styled.div`
  padding: 0px 30px;
`;

export const ImageDiv = styled.div`
  background-image: url(${(props) => props.src});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 600px;
  margin-bottom: 20px;
`;

export const QuickActionButton = styled(DecisionTreeButton)`
  background-color: ${colors.fullColoredButtonBackgroundActive};
  color: white;
  border: none;
  &:hover {
    background-color: ${colors.fullColoredButtonBackgroundActive + '95'};
  }
`;

export const QuestionWrapper = styled.div`
  color: ${colors.darkGray1};
  border: 1px solid ${colors.lightGray6};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  font-size: 11px;
`;

export const QuestionHeader = styled.div`
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${colors.darkWhite2};
  font-weight: 500;
  line-height: 18px;
  padding: 0px 16px;
  padding-right: 6px;
`;

export const QuestionText = styled.div`
  font-weight: 400;
  line-height: 16px;
  padding: 16px;
`;

export const QuestionAction = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: right;
  font-weight: 400;
  line-height: 16px;
  padding: 16px;
`;

export const QuestionCopyButton = styled.button`
  border: none;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
